import { formatAddress } from "../helpers.js";
import i18next from "../i18n";
import View from "./View";

class AddressView extends View {
  _addressValidationField = document.querySelector(".address-validation");
  _apartmentNumberField = document.querySelector("#apartment");
  _data;
  _formAddress = document.querySelector(".form-edit-address");
  _initialValues = {};
  _lookupState = null;
  _saveBtn = document.querySelector("#save-address");

  _clear() {
    this._formAddress.reset();
  }

  _showAddressError(event, message) {
    const SHAKEDURATION = 1000;
    const addressContainer = document.querySelector(".address-container");

    this._addressValidationField.textContent = message;
    this._addressValidationField.style.display = "block";
    this._addressField.style.marginBottom = "5.5px";

    addressContainer.classList.add("shake");
    setTimeout(() => {
      addressContainer.classList.remove("shake");
    }, SHAKEDURATION);

    event.preventDefault();
    return false;
  }

  // Check if input values have changed
  checkFormChanged() {
    const MAX_ADDRESS_LENGTH = 256;
    const MIN_APARTNUMBER_VALUE = 0;

    const isValid =
      this._addressField.value !== "" ||
      this._addressField.value.length <= MAX_ADDRESS_LENGTH ||
      this._apartmentNumberField.value >= MIN_APARTNUMBER_VALUE;

    let formChanged = false;

    Array.from(this._formAddress.elements).forEach((element) => {
      if (
        element.type !== "submit" &&
        element.value !== this._initialValues[element.name] &&
        isValid
      ) {
        formChanged = true;
      }

      if (formChanged === false) {
        // Hide address validation field
        this._addressValidationField.style.display = "none";
      }
    });

    // Enable or disable the save button based on changes
    this._saveBtn.disabled = !formChanged;
  }

  handlerSaveUserAddress(handler) {
    const DELAY_TIMEOUT_MS = 300;

    this._saveBtn.addEventListener(
      "click",
      this.debounce((event) => {
        // First, run the validations
        if (this.validateAddress(event)) {
          // Call the handler function if both validations pass
          handler(event);
        }
      }, DELAY_TIMEOUT_MS).bind(this),
    );
  }

  // Initialize event listeners to control the save button state
  initSaveBtn() {
    // Add event listener to each input field
    Array.from(this._formAddress.elements).forEach((element) => {
      if (element.type !== "submit") {
        element.addEventListener("input", this.checkFormChanged.bind(this));
      }
    });
  }

  // Prevent form submission
  preventSaveBtnClick() {
    this._saveBtn.addEventListener("click", (event) => event.preventDefault());
  }

  // Information of the logged-in user is located in this._data
  renderData(data) {
    this._data = data;

    // Clear the content of the form
    this._clear();

    // Fill required fields
    this._addressField.value = formatAddress(
      this._data?.address,
      this._data?.city,
    );
    this._apartmentNumberField.value = this._data?.apartmentNumber;

    return true;
  }

  renderError(message = i18next.t("error.addressInfo")) {
    this._clearModalError();
    this._errorContainer.textContent = message;
    this.openModalError();
  }

  renderValidation() {
    this._saveBtn.onclick = (event) => {
      this.validateAddress(event);
    };
  }

  // Called by the controller after each address lookup to record what the API returned.
  // hasAddresses: true if the API returned selectable address suggestions.
  // validationKey: an i18n key describing the validation error, or null if the address is valid.
  setLookupState(hasAddresses, validationKey) {
    this._lookupState = { hasAddresses, validationKey };
  }

  // Store the initial values of the form inputs
  storeInitialValues() {
    Array.from(this._formAddress.elements).forEach((element) => {
      if (element.type !== "submit") {
        this._initialValues[element.name] = element.value;
      }
    });
  }

  validateAddress(event) {
    const MIN_ADDRESS_LENGTH = 10;

    if (this._addressField.value.trim().length < MIN_ADDRESS_LENGTH) {
      return this._showAddressError(
        event,
        i18next.t("address.completeAddress"),
      );
    }

    if (
      this._lookupState !== null &&
      !this._lookupState.hasAddresses &&
      this._lookupState.validationKey
    ) {
      return this._showAddressError(
        event,
        i18next.t(this._lookupState.validationKey),
      );
    }

    // Hide address validation field
    this._addressValidationField.style.display = "none";

    // Adjust margin
    this._addressValidationField.style.marginBottom = "12.5px";

    return true;
  }
}

export default new AddressView();
